import { HypeboardTimeframe } from "@dripit/types";

export const TIMEFRAMES = [
  { id: HypeboardTimeframe["1D"], labelKey: "1d" },
  { id: HypeboardTimeframe["7D"], labelKey: "7d" },
  { id: HypeboardTimeframe["30D"], labelKey: "30d" },
];
